import './app.less';

import config from '../config';
import banner from './banner';
import invite from './invite';
import mark from '../mark';
import dialog from './dialog';
import player from './video';
import menu from './menu';
import swiperInit from './swiper';
import utils from './utils';

import '../user';

utils.wxShare();

invite.start();

player.init();

const ua = navigator.userAgent;
const isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);

let is2 = 0;
if (!isMobile) {
  banner.backAni();
  banner.mouseMove();
  is2 = 2;
}

dialog.init(is2);
menu.init(is2);


if (!($('.applyBtn button').hasClass('disable'))) {
  $('.applyBtn').click(function () {
    $('.applyBtn button').addClass('disable')
    dialog.show(is2)
  })
}

if (!($('.applyBtn-web').hasClass('disable'))) {
  $('.applyBtn-web').click(function () {
    $('.applyBtn-web').addClass('disable')
    dialog.show(is2)
  })
}


const accountUrl = config.accountUrl;
const apiUrl = config.apiUrl;
const caimiUrl = config.caimiUrl;
const facedetectUrl = config.facedetectUrl;
const httpProtocol = config.httpProtocol;
const loginDirect = config.loginDirect;
const registerDirect = config.registerDirect;
const webUrl = config.webUrl;
const staticUrl = config.staticUrl;
const spmMark = 'xhzy_mp_index';

// 设置跳转链接
const urlArr = [
  {
    name: 'BannerUrl',
    url: `${loginDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'LoginUrl',
    url: `${loginDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'RegisterUrl',
    url: `${registerDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'CopyrightLogin',
    url: `${httpProtocol}${webUrl}/banquan/all`
  }, {
    name: 'TTSLoginUrl',
    url: `${httpProtocol}${webUrl}/tts`
  }, {
    name: 'FenfaLoginUrl',
    url: `${httpProtocol}${webUrl}/fenfa`
  }, {
    name: 'CaimiUrl',
    url: `${caimiUrl}?from=${spmMark}`
  }, {
    name: 'FaceDetectUrl',
    url: `${httpProtocol}${webUrl}/face`
  }, {
    name: 'PersonaUrl',
    url: `${httpProtocol}${webUrl}/persona`
  }, {
    name: 'TianchengUrl',
    url: `${httpProtocol}${webUrl}/2410`
  }, {
    name: 'ChatbotUrl',
    url: `${httpProtocol}${webUrl}/chatbot`
  }
];

const solution = [
  {
    title: "版权保护",
    subtitle: "原创内容快速版权登记和监测系统",
    link: "",
    intro: [
      {
        title: "快速登记",
        info: "填写旗下网站，即可自动收录稿件"
      },
      {
        title: "监测报告",
        info: "可视化数据报表，侵权情况一目了然"
      }
    ]
  },
  {
    title: "用户画像",
    subtitle: "媒体受众行为偏好大数据分析服务",
    link: "",
    intro: [
      {
        title: "勾勒用户画像",
        info: "基于新华智云大数据矩阵，10+领域，1000+维度，洞察用户特征"
      },
      {
        title: "多种接入方式",
        info: "精准定位不同用户群，让产品迭代和用户运营有的放矢"
      }
    ]
  },
  // {
  //   title:"语音合成",
  //   subtitle:"业界领先的文字转语音合成工具",
  //   link:"",
  //   intro:[
  //     {
  //       title:"音质逼真",
  //       info:"男声女声任你选择，媲美真人音质"
  //     },
  //     {
  //       title:"便捷实用",
  //       info:"音频一键生成，轻松试听下载"
  //     }
  //   ]
  // },
  {
    title: "人脸核查",
    subtitle: "基于人脸识别的新闻事实核查服务",
    link: "",
    intro: [
      {
        title: "精准识别",
        info: "200+面部特征点精细定位，算法精度业内领先"
      },
      {
        title: "特定人物监测",
        info: "从海量图片中识别指定对象，毫秒级响应"
      }
    ]
  },
  {
    title: "智能会话",
    subtitle: "新闻场景智能问答机器人",
    link: "",
    intro: [
      {
        title: "可以互动的新闻",
        info: "捕捉用户喜好，深度定制个性化新闻"
      },
      {
        title: "多种接入方式",
        info: "赋予公众号、微博、App更丰富的新闻分发场景"
      }
    ]
  }
];

urlArr.map((item) => {
  if (isMobile) return;
  $('.' + item.name).attr('href', item.url);
});

// 检查是否已登录
// $.ajax({
//   url: httpProtocol + accountUrl + '/api/uic/get/user.json',
//   jsonp: 'callback',
//   dataType: 'jsonp',
//   success: (data) => {
//     var ua = navigator.userAgent;
//     var isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);
//     if (data && data.code === 'SW-010000' && window.swToken && !isMobile && !location.pathname.split('/index.html/confirm/')[1]) {
//       // 登录成功
//       location.href = `${httpProtocol}${webUrl}/banquan/all?from=${spmMark}`;
//     } else {
//       // 没有检测到是否登录
//     }
//   },
//   error: (err) => {
//     // 请求失败
//     console.log('error', err);
//   }
// });

// $('.product-item').click((e) => {
//   const hasMobile = $(e.currentTarget).hasClass('mobile');
//   $('.product-item').removeClass('mobile');
//   if (hasMobile && location.pathname.split('/index.html/confirm/')[1]) return;
//   $(e.currentTarget).addClass('mobile');
// });
$(document).ready(function () {
  swiperInit.init(isMobile);
});

if (isMobile) {
  $('.product-item').addClass('mobile');
}

$('.product-item').hover(() => {
  $('.product-item').removeClass('active');
});

if (!isMobile) {
  $('.product-item.firstItem').addClass('active');
}

$(window).resize((e) => {
  if (e.target && e.target.innerWidth < 768) {
    $('.product-item.firstItem').removeClass('active');
  }
});

// mark start
$('.LoginUrl').click(() => {
  mark.markPoint('home_login');
});
$('.RegisterUrl').click(() => {
  mark.markPoint('home_register');
});
$('.CopyrightLogin').click(() => {
  mark.markPoint('home_copyright');
});
$('.TTSLoginUrl').click(() => {
  mark.markPoint('home_tts');
});
$('.FenfaLoginUrl').click(() => {
  mark.markPoint('home_fenfa');
});
$('.CaimiUrl').click(() => {
  mark.markPoint('home_caimi');
});
$('.FaceDetectUrl').click(() => {
  mark.markPoint('home_face');
});
$('.TianchengUrl').click(() => {
  mark.markPoint('home_tiancheng');
});
$('.PersonaUrl').click(() => {
  mark.markPoint('home_persona');
});
$('.ChatbotUrl').click(() => {
  mark.markPoint('home_chatbot');
});
$('.BannerUrl').click(() => {
  mark.markPoint('home_banner');
});
// mark end
//
var timer = null;
// 滚动动画
function scrollAnimation() {
  console.log($('#scroll ul li:first').height());
  var $scrollList = $('#scroll ul');
  var scrollHeight = $('#scroll ul li:first').height();
  var $activeEle = $('#scroll').find('.active');

  // setTimeout(function(){
  $activeEle.removeClass('active');
  $activeEle.next().addClass("active");
  // },600)

  $scrollList.stop().animate({ marginTop: -scrollHeight }, 600, function () {
    $scrollList.css({ marginTop: 0 }).find("li:first").appendTo($scrollList);
  })
}
timer = setInterval(function () {
  scrollAnimation();
}, 3000)


$('.solution-tab__item').hover(function () {
  var index = $(".solution-tab__item").index(this);
  $('.solution-tab__item').removeClass('active');
  $('.solution-tab__item').eq(index).addClass('active');
  $('.solution-intro-1 h2').text(solution[index].title)
  $('.solution-intro-1 p').text(solution[index].subtitle)
  $('.solution-intro-2 h6').text(solution[index].intro[0].title)
  $('.solution-intro-2 p').text(solution[index].intro[0].info)
  $('.solution-intro-3 h6').text(solution[index].intro[1].title)
  $('.solution-intro-3 p').text(solution[index].intro[1].info)
})





// WEBPACK FOOTER //
// ./src/pages/index/app.js